import styled from 'styled-components';
import media from "styled-query"

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
  background: var(--gray);

  /* background: #0080003b; */
`;

export const Content = styled.div`
  width: 1120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  
  ${media.lessThan("1023px")`
    margin: 0 24px;
    flex-direction: column;
  `}
  /* background: #ff000036; */
`;